import { useState } from 'react';
import { whoisService } from '../services/whoisService';
import type { WhoisResult } from '../types/domain.types';

/**
 * Imperatively trigger a WHOIS lookup. Returns the result, loading flag,
 * any validation/transport error, and a `lookup(query)` function to call.
 */
export function useWhois() {
  const [result, setResult] = useState<WhoisResult | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  async function lookup(query: string): Promise<void> {
    setIsLoading(true);
    setError(null);
    setResult(null);
    try {
      const r = await whoisService.lookup(query);
      setResult(r);
    } catch (err: unknown) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  }

  function reset() {
    setResult(null);
    setError(null);
    setIsLoading(false);
  }

  return { result, isLoading, error, lookup, reset };
}
